class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);

/* WBP: make parent print categories with sub-categories directly reachable. */
function wbpAddParentCollectionLinks() {
  const destinations = {
    Dorset: '/collections/prints/Dorset'
  };

  document.querySelectorAll('#shopify-section-header summary').forEach((summary) => {
    const title = summary.textContent.replace(/\s+/g, ' ').trim();
    const url = destinations[title];
    if (!url || summary.dataset.wbpParentLinkAdded === 'true') return;

    const details = summary.parentElement;
    const content = summary.nextElementSibling;
    if (!details || details.tagName !== 'DETAILS' || !content) return;

    const list = content.matches('ul') ? content : content.querySelector('ul');
    if (!list || list.querySelector('[data-wbp-parent-collection-link]')) return;

    const item = document.createElement('li');
    const link = document.createElement('a');
    link.href = url;
    link.textContent = `View all ${title}`;
    link.setAttribute('data-wbp-parent-collection-link', 'true');
    link.className = content.matches('ul')
      ? 'header__menu-item list-menu__item link link--text focus-inset caption-large'
      : 'menu-drawer__menu-item link link--text list-menu__item focus-inset';

    item.appendChild(link);
    list.prepend(item);
    summary.dataset.wbpParentLinkAdded = 'true';
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', wbpAddParentCollectionLinks);
} else {
  wbpAddParentCollectionLinks();
}
